import _inject from "@stylexjs/stylex/lib/stylex-inject";
var _inject2 = _inject;
import * as stylex from "@stylexjs/stylex";
import { useQuery } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import { ArrowRight, CalendarDays } from "lucide-react";
import { useId } from "react";
import { EventStatusBadge } from "@/components/shared/event-status-badge";
import { GuildEventRelativeTime } from "@/components/shared/guild-event-relative-time";
import { StatusAlert } from "@/components/shared/status-alert";
import { Button } from "@/components/ui/button";
import { CardContent } from "@/components/ui/card";
import { GUILD_EVENTS_SCHEDULE_CONFIG } from "@/core/guild-events/types";
import { type GuildEventRecord, guildEventsApi } from "@/lib/guild-events-api";
import { guildEventsKeys } from "@/lib/query-keys";
import { getMemberEventRowPresentation } from "@/routes/_authed/events";
_inject2({
  ltr: ".x1n2onr6{position:relative}",
  priority: 3000
});
_inject2({
  ltr: ".x178xt8z{border-top-width:1px}",
  priority: 4000
});
_inject2({
  ltr: ".x13fuv20{border-top-style:solid}",
  priority: 4000
});
_inject2({
  ltr: ".x1wepgej{border-top-color:color-mix(in oklab,var(--border) 40%,transparent)}",
  priority: 4000
});
_inject2({
  ltr: ".x1mcfnh7{padding-top:1.25rem}",
  priority: 4000
});
_inject2({
  ltr: ".xrvj5dj{display:grid}",
  priority: 3000
});
_inject2({
  ltr: ".x8233eu{gap:.75rem}",
  priority: 2000
});
_inject2({
  ltr: ".x78zum5{display:flex}",
  priority: 3000
});
_inject2({
  ltr: ".x1a02dak{flex-wrap:wrap}",
  priority: 3000
});
_inject2({
  ltr: ".x6s0dn4{align-items:center}",
  priority: 3000
});
_inject2({
  ltr: ".x1qughib{justify-content:space-between}",
  priority: 3000
});
_inject2({
  ltr: ".x13z6uf9{gap:.5rem}",
  priority: 2000
});
_inject2({
  ltr: ".x1enigpx{gap:.125rem}",
  priority: 2000
});
_inject2({
  ltr: ".xkpwil5{font-size:.875rem}",
  priority: 3000
});
_inject2({
  ltr: ".x8r4c90{line-height:1.25rem}",
  priority: 3000
});
_inject2({
  ltr: ".x1s688f{font-weight:600}",
  priority: 3000
});
_inject2({
  ltr: ".xcdlrvm{width:1rem}",
  priority: 4000
});
_inject2({
  ltr: ".x1l36t39{height:1rem}",
  priority: 4000
});
_inject2({
  ltr: ".xrvchh{color:var(--muted-foreground)}",
  priority: 3000
});
_inject2({
  ltr: ".xboafo0{font-size:.75rem}",
  priority: 3000
});
_inject2({
  ltr: ".xl2ypbo{line-height:1rem}",
  priority: 3000
});
_inject2({
  ltr: ".x3nfvp2{display:inline-flex}",
  priority: 3000
});
_inject2({
  ltr: ".x2lah0s{flex-shrink:0}",
  priority: 3000
});
_inject2({
  ltr: ".xvh977a{gap:.25rem}",
  priority: 2000
});
_inject2({
  ltr: ".x6i6fhv{border-radius:.375rem}",
  priority: 2000
});
_inject2({
  ltr: ".xmkeg23{border-width:1px}",
  priority: 2000
});
_inject2({
  ltr: ".x1y0btm7{border-style:solid}",
  priority: 2000
});
_inject2({
  ltr: ".x1i58g6b{border-color:color-mix(in oklab,var(--border) 60%,transparent)}",
  priority: 2000
});
_inject2({
  ltr: ".x1ryrjj2{padding-inline:.75rem}",
  priority: 2000
});
_inject2({
  ltr: ".x1bilvtl{padding-block:.375rem}",
  priority: 2000
});
_inject2({
  ltr: ".xk50ysn{font-weight:500}",
  priority: 3000
});
_inject2({
  ltr: ".xjktubg:hover{background-color:color-mix(in oklab,var(--card) 80%,transparent)}",
  priority: 3130
});
_inject2({
  ltr: ".x1xvt488{width:.875rem}",
  priority: 4000
});
_inject2({
  ltr: ".xf08kfj{height:.875rem}",
  priority: 4000
});
_inject2({
  ltr: ".xu15cu9{height:3.5rem}",
  priority: 4000
});
_inject2({
  ltr: ".x1ku5rj1{place-items:center}",
  priority: 2000
});
_inject2({
  ltr: ".x1yt6v20{border-radius:.75rem}",
  priority: 2000
});
_inject2({
  ltr: ".x13x64dk{background-color:color-mix(in oklab,var(--card) 55%,transparent)}",
  priority: 3000
});
_inject2({
  ltr: ".x13eudtd{padding-block:.625rem}",
  priority: 2000
});
_inject2({
  ltr: ".xeuugli{min-width:0}",
  priority: 4000
});
_inject2({
  ltr: ".xss6m8b{font-variant-numeric:tabular-nums}",
  priority: 3000
});
_inject2({
  ltr: ".xb3r6kr{overflow:hidden}",
  priority: 2000
});
_inject2({
  ltr: ".xlyipyv{text-overflow:ellipsis}",
  priority: 3000
});
_inject2({
  ltr: ".xuxw1ft{white-space:nowrap}",
  priority: 3000
});
_inject2({
  ltr: ".x1tbvfm1{margin-top:.25rem}",
  priority: 4000
});
_inject2({
  ltr: "@media (min-width: 768px){.xa41o0o.xa41o0o{display:none}}",
  priority: 3200
});
_inject2({
  ltr: ".x1s85apg{display:none}",
  priority: 3000
});
_inject2({
  ltr: "@media (min-width: 768px){.x12gs5cb.x12gs5cb{display:block}}",
  priority: 3200
});
const styles = {
  content: {
    kVAEAm: "x1n2onr6",
    kEafiO: "x178xt8z",
    kPef9Z: "x13fuv20",
    kLZC3w: "x1wepgej",
    kLKAdn: "x1mcfnh7",
    $$css: true
  }
};
export function TodayEventsStrip({
  canOpenEventDetails
}: {
  canOpenEventDetails: boolean;
}) {
  const todayQuery = useQuery({
    queryKey: guildEventsKeys.memberToday(),
    queryFn: guildEventsApi.listTodayEvents
  });
  const headingId = useId();
  const items = todayQuery.data ?? [];
  return <CardContent stylexStyle={styles.content}>
      <section aria-labelledby={headingId} className="xrvj5dj x8233eu">
        <div className="x78zum5 x1a02dak x6s0dn4 x1qughib x13z6uf9">
          <div className="xrvj5dj x1enigpx">
            <h2 id={headingId} className="x78zum5 x6s0dn4 x13z6uf9 xkpwil5 x8r4c90 x1s688f">
              <CalendarDays className="xcdlrvm x1l36t39 xrvchh" aria-hidden="true" />
              Today's events
            </h2>
            <p className="xboafo0 xl2ypbo xrvchh">
              Times shown in guild time ({GUILD_EVENTS_SCHEDULE_CONFIG.timezone}
              )
            </p>
          </div>
          <Link to="/events" className="x3nfvp2 x2lah0s x6s0dn4 xvh977a x6i6fhv xmkeg23 x1y0btm7 x1i58g6b x1ryrjj2 x1bilvtl xkpwil5 x8r4c90 xk50ysn xjktubg">
            View all events
            <ArrowRight className="x1xvt488 xf08kfj" aria-hidden="true" />
          </Link>
        </div>

        {todayQuery.isError ? <StatusAlert tone="danger">
            <div className="x78zum5 x6s0dn4 x1qughib x8233eu">
              <span>Failed to load today's events.</span>
              <Button type="button" variant="outline" size="sm" disabled={todayQuery.isFetching} onClick={() => void todayQuery.refetch()}>
                Retry
              </Button>
            </div>
          </StatusAlert> : todayQuery.data === undefined ? <div aria-busy="true" aria-live="polite" className="xrvj5dj xu15cu9 x1ku5rj1 x1yt6v20 xmkeg23 x1y0btm7 x1i58g6b x13x64dk xkpwil5 x8r4c90 xrvchh" role="status">
            Loading today's events…
          </div> : items.length === 0 ? <p className="x1yt6v20 xmkeg23 x1y0btm7 x1i58g6b x13x64dk x1ryrjj2 x13eudtd xkpwil5 x8r4c90 xrvchh">No events scheduled for today.</p> : <ol className="xrvj5dj x13z6uf9">
            {items.map(event => <TodayEventRow key={event.id} event={event} canOpenEventDetails={canOpenEventDetails} />)}
          </ol>}
      </section>
    </CardContent>;
}
function TodayEventRow({
  event,
  canOpenEventDetails
}: {
  event: GuildEventRecord;
  canOpenEventDetails: boolean;
}) {
  const presentation = getMemberEventRowPresentation(event);
  return <li>
      <Link to="/events/$eventId" params={{
      eventId: event.id
    }} disabled={!canOpenEventDetails} className="x78zum5 x6s0dn4 x1qughib x8233eu x1yt6v20 xmkeg23 x1y0btm7 x1i58g6b x13x64dk xjktubg x1ryrjj2 x13eudtd">
        <div className="xeuugli">
          <div className="x78zum5 xeuugli x6s0dn4 x13z6uf9">
            <span className="x2lah0s xboafo0 xl2ypbo xrvchh xss6m8b">{presentation.when}</span>
            <GuildEventRelativeTime startAt={event.startAt} />
            <span className="xb3r6kr xlyipyv xuxw1ft xkpwil5 x8r4c90 xk50ysn">{event.title}</span>
            <EventStatusBadge status={event.status} />
          </div>
          <div className="x1tbvfm1 xb3r6kr xlyipyv xuxw1ft xboafo0 xl2ypbo xrvchh xa41o0o">{presentation.state}</div>
        </div>
        <div className="x1s85apg x2lah0s xboafo0 xl2ypbo xrvchh x12gs5cb">{presentation.state}</div>
      </Link>
    </li>;
}